import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {CoverageSummaryModal} from './modal';
import {faFile} from '@fortawesome/fontawesome-pro-solid';

/**
 * Wrapper component to handle state for the coverage summary modal
 */
export const CoverageSummary = ({rowData, column, styleSheet}) => {
  const [showSummaryModal, setShowSummaryModal] = useState(false);

  const handleCoverageSummaryModal = (e) => {
    e.preventDefault();
    setShowSummaryModal(true);
  };

  switch (column.meta?.handler) {
    case 'modal':
    default:
      return (
        <>
          <a
            id={rowData.id}
            onClick={handleCoverageSummaryModal}
            data-testid={`coverage-summary-link-${rowData.id}`}
            title={column.meta.title}
          >
            <FontAwesomeIcon icon={faFile} size={'2x'} />
          </a>
          <CoverageSummaryModal
            column={column}
            rowData={rowData}
            styleSheet={styleSheet}
            showSummaryModal={showSummaryModal}
            handleHide={() => setShowSummaryModal(false)}
          />
        </>
      );
  }
};
